import React, { Component } from "react";
import queryString from "query-string";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { formatCurrency, formatNumber } from "../../utils/helpers";
import dayjs from "dayjs";
import Loader from "../general/Loader";

export default class ReporteNominas extends Component {
    state = {
        empleados: false,
        categorias: [],
        produccionOperadores: [],
        viajes: 0,
    };
    componentDidMount() {
        this.getReporte();
    }
    getReporte = async () => {
        const token = auth.getToken();

        const res = await fetch(apiUrl(`reportes` + window.location.search), {
            method: "get",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.setState({
                empleados: response.data.empleados.filter(
                    (emp) => emp.toneladas > 0
                ),
                categorias: response.data.categorias,
                produccionOperadores: response.data.produccionOperadores,
                viajes: response.data.viajes,
            });
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const {
            empleados,
            viajes,
            categorias,
            produccionOperadores,
        } = this.state;

        if (!empleados) {
            return <Loader />;
        }

        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];
        const query = queryString.parse(window.location.search);

        const totalSueldoBruto = empleados.reduce((acc, empleado) => {
            return acc + empleado.sueldoBruto;
        }, 0);

        const totalDescuentos = empleados.reduce((acc, empleado) => {
            return acc + empleado.descuentos;
        }, 0);

        const totalSueldo = empleados.reduce((acc, empleado) => {
            return acc + empleado.total;
        }, 0);

        const totalToneladasGlobal = categorias.reduce((acc, cat) => {
            return acc + parseFloat(cat.toneladas) / 1000;
        }, 0);

        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>
                        Reporte de Producción de Empleados{" "}
                        {query.contrato === "informal" ? "Informales" : ""}
                    </h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {dayjs(query.desde).format("DD/MM/YYYY")} -{" "}
                        {dayjs(query.hasta).format("DD/MM/YYYY")}
                    </div>
                    <div className='col-md-12 p-b-10'></div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>
                            EMPLEADOS: {empleados.length}
                        </div>

                        <div className='float-right'>
                            <h3>
                                GASTO TOTAL:{" "}
                                {formatCurrency(
                                    empleados.reduce(
                                        (acc, empleado) =>
                                            acc + parseFloat(empleado.total),
                                        0
                                    )
                                )}
                            </h3>
                        </div>
                    </div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Cargo</th>
                            <th className='text-center'>Toneladas</th>
                            <th className='text-right'>Sueldo Fijo</th>
                            <th className='text-right'>Sueldo Bruto</th>
                            <th className='text-right'>Descuentos</th>
                            <th className='text-right'>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {empleados.map((empleado, index) => {
                            return (
                                <tr key={index}>
                                    <td>{empleado.codigo}</td>
                                    <td>{empleado.nombre}</td>
                                    <td>{empleado.cargo}</td>
                                    <td className='text-center'>
                                        {formatNumber(empleado.toneladas)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(
                                            parseFloat(empleado.sueldoFijo)
                                        )}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(empleado.sueldoBruto)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(empleado.descuentos)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(empleado.total)}
                                    </td>
                                </tr>
                            );
                        })}
                        <tr style={{ fontWeight: "bold" }}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>TOTALES =></td>
                            <td className='text-right'>
                                {formatCurrency(totalSueldoBruto)}
                            </td>
                            <td className='text-right'>
                                {formatCurrency(totalDescuentos)}
                            </td>
                            <td className='text-right'>
                                {formatCurrency(totalSueldo)}
                            </td>
                        </tr>
                    </tbody>
                </table>
                {empleados.length > 0 && (
                    <div className='sumary m-t-70'>
                        <h3 className='text-center'>
                            Produccion por rango de fechas
                        </h3>
                        <table className='table text-center m-b-25'>
                            <thead>
                                <tr>
                                    <th width='33.33%'>
                                        Cantidad de Viajes Realizados
                                    </th>
                                    <th width='33.33%'>
                                        Toneladas Promedio por Viajes
                                    </th>
                                    <th width='33.33%'>
                                        Cantidad de Toneladas
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{formatNumber(viajes)}</td>
                                    <td>
                                        {formatNumber(
                                            totalToneladasGlobal / viajes
                                        )}
                                    </td>
                                    <td>
                                        {formatNumber(totalToneladasGlobal)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className='table m-t-45'>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className='text-right'>
                                        <strong>DISTRIBUCIÓN DE PAGOS</strong>
                                    </td>
                                </tr>
                                {categorias.map((cat) => (
                                    <tr key={cat.nombre}>
                                        <td>
                                            <strong>{cat.nombre}</strong>
                                        </td>
                                        <td className='text-right'>
                                            <div>
                                                <strong>Toneladas</strong>
                                            </div>
                                            <div>
                                                {formatNumber(
                                                    parseFloat(
                                                        cat.toneladas / 1000
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td></td>
                                        <td className='text-right'>
                                            <Operadores
                                                categoria={cat.nombre}
                                                produccion={
                                                    produccionOperadores
                                                }
                                                toneladas={cat.toneladas}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}

function Operadores({ categoria, produccion, toneladas }) {
    const filter = produccion
        .filter((item) => {
            return item.categoria === categoria;
        })
        .reduce((acc, item) => {
            const nombre =
                item.operador &&
                item.operador.toLowerCase().indexOf("ayudante") !== -1
                    ? "ayudante"
                    : item.operador;
            acc[nombre] = {
                sueldo: item.sueldo,
                nombre: nombre,
                toneladas: !acc[nombre]
                    ? parseFloat(item.toneladas)
                    : parseFloat(acc[nombre].toneladas) +
                      parseFloat(item.toneladas),
            };
            return acc;
        }, {});
    console.log(filter, "filter");
    return (
        <div className='table'>
            {Object.keys(filter).map((item) => {
                return (
                    <div key={item}>
                        {filter[item].nombre}:{" "}
                        {formatCurrency(
                            (filter[item].sueldo * filter[item].toneladas) /
                                1000
                        )}
                    </div>
                );
            })}
        </div>
    );
}
